import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useUpdatePackageOptionsMobileLine } from '@/hooks/useLineActions';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export function ConfirmTogglePackageOptionDialog({
  isOpen,
  onClose,
  onConfirm,
  optionLabel,
  packageOptionLabel,
  isEnabled,
  lineId,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  optionLabel: string;
  packageOptionLabel: string;
  isEnabled: boolean;
  lineId: string;
}) {
  const { mutate: updatePackageOptionsMobileLine, isPending } =
    useUpdatePackageOptionsMobileLine();

  const handleConfirm = () => {
    updatePackageOptionsMobileLine(
      {
        lineId: lineId,
        packageOptions: [{ label: packageOptionLabel, isEnabled }],
      },
      {
        onSuccess: () => {
          onClose();
          toast.success(
            `Option "${optionLabel}" ${
              isEnabled ? 'activée' : 'désactivée'
            } avec succès`
          );
          onConfirm();
        },
        onError: (error) => {
          toast.error(
            `Erreur lors de la modification de l'option: ${
              error.message || 'Erreur inconnue'
            }`
          );
        },
      }
    );
  };
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirmer le changement</DialogTitle>
          <DialogDescription>
            Êtes-vous sûr de vouloir {isEnabled ? 'activer' : 'désactiver'}{' '}
            l'option "{optionLabel}" ?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onClose}>
            Annuler
          </Button>
          <Button onClick={handleConfirm} disabled={isPending}>
            {isPending ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Enregistrement...
              </>
            ) : (
              'Confirmer'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
